"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _intl = require("@kyruus/intl");
var _MobileTeleHealth = _interopRequireDefault(require("@kyruus/react-ikons/MobileTeleHealth"));
var _Phone = _interopRequireDefault(require("@kyruus/react-ikons/Phone"));
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _VisitTypes = require("../../lib/constants/VisitTypes");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const VisitLabel = _ref => {
  let {
    Wrapper,
    IconWrapper,
    iconSize,
    LabelWrapper,
    Label,
    type
  } = _ref;
  let message = {};
  let Icon;
  switch (type) {
    case _VisitTypes.PHONE:
      Icon = /*#__PURE__*/_react.default.createElement(_Phone.default, {
        size: iconSize
      });
      message = _messages.default.appointmentPhoneTitle;
      break;
    case _VisitTypes.VIDEO:
      Icon = /*#__PURE__*/_react.default.createElement(_MobileTeleHealth.default, {
        size: iconSize
      });
      message = _messages.default.appointmentVideoTitle;
      break;
    default:
      message = _messages.default.appointmentInPersonTitle;
  }
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-testid": "VisitTypeLabel"
  }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, Icon), /*#__PURE__*/_react.default.createElement(LabelWrapper, null, /*#__PURE__*/_react.default.createElement(Label, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, message))));
};
VisitLabel.defaultProps = {
  Wrapper: _react.Fragment,
  IconWrapper: _react.Fragment,
  LabelWrapper: _react.Fragment,
  Label: _react.Fragment,
  iconSize: '18px',
  type: _VisitTypes.IN_PERSON
};
var _default = exports.default = VisitLabel;
VisitLabel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VisitLabel",
  "props": {
    "Wrapper": {
      "defaultValue": {
        "value": "Fragment",
        "computed": true
      },
      "required": false
    },
    "IconWrapper": {
      "defaultValue": {
        "value": "Fragment",
        "computed": true
      },
      "required": false
    },
    "LabelWrapper": {
      "defaultValue": {
        "value": "Fragment",
        "computed": true
      },
      "required": false
    },
    "Label": {
      "defaultValue": {
        "value": "Fragment",
        "computed": true
      },
      "required": false
    },
    "iconSize": {
      "defaultValue": {
        "value": "'18px'",
        "computed": false
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "IN_PERSON",
        "computed": true
      },
      "required": false
    }
  }
};